import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalConfig } from '@core/models/modal-config.model';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-consultant-contact-success-modal',
  templateUrl: './consultant-contact-success-modal.component.html',
  styleUrls: ['./consultant-contact-success-modal.component.scss'],
})
export class ConsultantContactSuccessModalComponent {
  buttonText: string = $localize`CONTINUE`;

  modalConfig: ModalConfig = {
    hideCloseButton: true,
    hideDismissButton: true,
    hideHeader: false,
    onDismiss: this.modalDone.bind(this),
    ngbModalOptions: {
      size: 'md',
      modalDialogClass: 'successModal',
    },
  };

  @Output() closed = new EventEmitter<void>();
  @Output() SucceededDone: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('successModal') private successModal: ModalComponent;

  constructor() {}

  open(): void {
    this.successModal.open();
  }

  onClose(): void {
    this.SucceededDone.emit();
    this.successModal.close();
  }

  private modalDone() {
    this.SucceededDone.emit();
    this.successModal.close();
  }
}
